import * as uuid from "uuid";
import styles from "../../../../styles/add-category.module.scss";
import { Button } from "../../../components/Button";
import { CurrencyInput } from "../../../components/CurrencyInput";
import { Hairline } from "../../../components/Hairline";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { Radio } from "../../../components/Radio";
import { Icon } from "../../../components/core/Icon";

const getEmptyExtraIngredient = (category) => ({
  name: "",
  type: "extraingredient",
  sizes: category.sizes,
  ref_id: uuid.v4(),
});

const getTotalCharacters = (item) => {
  return `${item.sku?.length > 0 ? item.sku?.length : 0}/60`;
};

const ExtraIngredientItem = ({ extra, onChange, onDelete }) => {
  return (
    <div className={styles.optionItem}>
      <div className="d-flex align-center mb-15">
        <Input
          floatLabel="Nome do extra"
          design="three"
          value={extra.name}
          onChange={(e) => onChange({ ...extra, name: e.target.value })}
          className="w-100"
        />
        <Button design="default-icon" onClick={onDelete} className="ml-15">
          <Icon name="trash" size="xl" />
        </Button>
      </div>
      <div className={styles.extras}>
        {extra.sizes.map((size, sizeIdx, sizes) => {
          return (
            <div div className={styles.extra}>
              <div className={styles.sizeName}>{size.name}</div>
              <div className="d-flex align-center mt-15 mb-25">
                <Input
                  label="Código SKU"
                  design="three"
                  placeholder="----"
                  maxLength={60}
                  className="w-100"
                  suffix2={getTotalCharacters(extra)}
                  value={size.sku}
                  onChange={(e) => {
                    onChange({
                      ...extra,
                      sizes: sizes.map((s, sIdx) => {
                        if (sIdx == sizeIdx) {
                          return { ...s, sku: e.target.value };
                        }
                        return s;
                      }),
                    });
                  }}
                />
              </div>

              <CurrencyInput
                design="three"
                value={size.price}
                onChange={(e, m, f) => {
                  onChange({
                    ...extra,
                    sizes: sizes.map((s, sIdx) => {
                      if (sIdx == sizeIdx) {
                        return { ...s, price: f };
                      }
                      return s;
                    }),
                  });
                }}
                placeholder="R$ 0,00"
                className="w-100"
                label="Preço"
              />

              {sizeIdx !== sizes.length - 1 && (
                <Hairline className="mt-15 mb-15" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const SetExtraIngredients = ({ category, mountPayload }) => {
  const handler = (e) => {
    mountPayload({ extra_ingredients: e });
  };

  const onDeleteExtra = (extraIngredientIndex) => {
    handler(
      category.extra_ingredients.filter(
        (e, eIdx) => eIdx != extraIngredientIndex
      )
    );
  };

  return (
    <>
      <Label>Esta categoria possui extras?</Label>
      <Radio
        family="has-extra-ingredients"
        value={false}
        checked={category.extra_ingredients.length > 0}
        className="mb-15"
        onChange={(value) => handler([])}
      >
        Não
      </Radio>
      <Radio
        family="has-extra-ingredients"
        value={true}
        checked={category.extra_ingredients.length > 0}
        onChange={(value) => handler([getEmptyExtraIngredient(category)])}
      >
        Sim
      </Radio>

      {category.extra_ingredients.length > 0 && (
        <>
          <Hairline className="mt-20 mb-20" />
          <Label>Quais são os extras?</Label>
          {category.extra_ingredients.map((eI, eIdx, extraIngredients) => {
            return (
              <ExtraIngredientItem
                extra={eI}
                onChange={(newExtraIngredient) => {
                  extraIngredients[eIdx] = newExtraIngredient;
                  handler(extraIngredients);
                }}
                onDelete={() => onDeleteExtra(eIdx)}
              />
            );
          })}
          <Button
            design="default-2"
            className="w-100 mt-20"
            onClick={() =>
              handler([
                ...category.extra_ingredients,
                getEmptyExtraIngredient(category),
              ])
            }
          >
            Adicionar extra
          </Button>
        </>
      )}
    </>
  );
};

export default SetExtraIngredients;
